var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.usage.lastUpdated
      ? _c("div", [
          _c("div", { staticClass: "row head" }, [
            _c("div", { staticClass: "col col-100" }, [
              _vm._v(
                "Overzicht bijgewerkt tot " +
                  _vm._s(_vm.usage.lastUpdated) +
                  " "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row row-single setting" }, [
            _c("div", { staticClass: "col col-100" }, [
              _vm.$root.app.platform == "android"
                ? _c("div", [
                    _c("span", { staticClass: "row__title" }, [
                      _vm._v("Totaal verbruik")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$root.app.platform == "ios"
                ? _c("div", { staticClass: "col col-50" }, [
                    _c("span", { staticClass: "row__title" }, [
                      _vm._v("Totaal verbruik")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$root.app.platform == "ios"
                ? _c("div", { staticClass: "col col-50 text-right light" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.usage.totalMinutesCalled) +
                        " min\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.usage.categories
              ? _c("div", { staticClass: "col col-100 usage-diagram" }, [
                  _vm.$root.app.platform == "android"
                    ? _c("div", { staticClass: "col col-50" }, [
                        _c(
                          "ul",
                          { staticClass: "usage-diagram__legenda" },
                          _vm._l(_vm.usage.categories, function(
                            category,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                staticClass: "legenda__item",
                                class: category.name
                                  .toLowerCase()
                                  .replace(/ /g, "-")
                                  .replace("085-", "")
                              },
                              [_vm._v(_vm._s(category.name))]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$root.app.platform == "android"
                    ? _c("div", { staticClass: "col col-50" }, [
                        _c(
                          "div",
                          { staticClass: "usage-diagram__donut" },
                          [
                            _vm._l(_vm.usage.categories, function(
                              category,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  staticClass: "donut__piece",
                                  class: {
                                    "donut__piece--gt50":
                                      category.circlePiece > 180
                                  },
                                  style: {
                                    transform:
                                      "rotate(" +
                                      category.circleDistance +
                                      "deg)"
                                  },
                                  attrs: {
                                    "data-title": category.totalMinutes + " min"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "donut__piece__item",
                                    class: category.name
                                      .toLowerCase()
                                      .replace(/ /g, "-")
                                      .replace("085-", ""),
                                    style: {
                                      transform:
                                        "rotate(" +
                                        category.circlePiece +
                                        "deg)"
                                    }
                                  }),
                                  _vm._v(" "),
                                  category.circlePiece > 180
                                    ? _c("div", {
                                        staticClass:
                                          "donut__piece__item donut__piece__item--fill",
                                        class: "cat-" + index
                                      })
                                    : _vm._e()
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "usage-diagram__donut__inner" },
                              [
                                _vm._v(
                                  _vm._s(_vm.usage.totalMinutesCalled) + " min"
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$root.app.platform == "ios"
                    ? _c(
                        "div",
                        { staticClass: "usage-diagram__bar" },
                        _vm._l(_vm.usage.categories, function(category, index) {
                          return _c("div", {
                            staticClass: "bar__piece",
                            class: category.name
                              .toLowerCase()
                              .replace(/ /g, "-")
                              .replace("085-", ""),
                            style: { width: category.percentage + "%" }
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$root.app.platform == "ios"
                    ? _c(
                        "ul",
                        { staticClass: "usage-diagram__legenda" },
                        _vm._l(_vm.usage.categories, function(category, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "legenda__item",
                              class: category.name
                                .toLowerCase()
                                .replace(/ /g, "-")
                                .replace("085-", "")
                            },
                            [_vm._v(_vm._s(category.name))]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.usage.categories
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.usage.categories, function(category, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "row row-list-item setting",
                        class: {
                          "row-last": _vm.usage.categories.length - 1 === index
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col col-100 usage",
                            class: category.name
                              .toLowerCase()
                              .replace(/ /g, "-")
                              .replace("085-", "")
                          },
                          [
                            _c("div", { staticClass: "row__title" }, [
                              _vm._v(_vm._s(category.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "small" }, [
                              _vm._v(
                                _vm._s(category.totalCalls) + " gesprekken"
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(category.totalMinutes) +
                                  " minuten"
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$root.app.platform == "ios"
            ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
            : _vm._e()
        ])
      : _c("div", [_vm._m(1), _vm._v(" "), _vm._m(2)]),
    _vm._v(" "),
    _vm.testGroup
      ? _c("div", { staticClass: "call-history" }, [
          _vm.callsCurrentMonth
            ? _c(
                "div",
                { staticClass: "current-month" },
                [
                  _c("div", { staticClass: "row head" }, [
                    _c("div", { staticClass: "col col-100" }, [
                      _vm._v(
                        _vm._s(
                          _vm.convertToMonthYear(
                            _vm.callHistoryCurrentMonth.periodStart.substring(
                              0,
                              10
                            )
                          )
                        ) + " "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "download",
                          on: { click: _vm.downloadCurrentMonth }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/send-invoice.svg")
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.callsCurrentMonth, function(call) {
                    return _c(
                      "div",
                      {
                        key: call.id,
                        staticClass: "row row-list-item setting"
                      },
                      [
                        _c("div", { staticClass: "call-type col col-50" }, [
                          call.type == "O"
                            ? _c("div", [
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v(_vm._s(call.calledNumber))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v("Uitgaand")
                                ])
                              ])
                            : _c("div", [
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v(_vm._s(call.telephoneNumber))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v("Inkomend")
                                ])
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col col-50" }, [
                          _c("div", { staticClass: "col col-90" }, [
                            _vm._v(
                              _vm._s(_vm.convertToDayMonth(call.date)) +
                                " " +
                                _vm._s(_vm.convertToClock(call.time))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col col-90" }, [
                            _vm._v(_vm._s(_vm.convertToDuration(call.duration)))
                          ]),
                          _vm._v(" "),
                          call.type == "O"
                            ? _c("div", { staticClass: "call-type-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/outboundcall.svg")
                                  }
                                })
                              ])
                            : _c("div", { staticClass: "call-type-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/inboundcall.svg")
                                  }
                                })
                              ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.callsPreviousMonth
            ? _c(
                "div",
                { staticClass: "previous-month" },
                [
                  _c("div", { staticClass: "row head" }, [
                    _c("div", { staticClass: "col col-100" }, [
                      _vm._v(
                        _vm._s(
                          _vm.convertToMonthYear(
                            _vm.callHistoryPreviousMonth.periodStart.substring(
                              0,
                              10
                            )
                          )
                        ) + " "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "download",
                          on: { click: _vm.downloadPreviousMonth }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/send-invoice.svg")
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.callsPreviousMonth, function(call) {
                    return _c(
                      "div",
                      {
                        key: call.id,
                        staticClass: "row row-list-item setting"
                      },
                      [
                        _c("div", { staticClass: "call-type col col-50" }, [
                          call.type == "O"
                            ? _c("div", [
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v(_vm._s(call.calledNumber))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v("Uitgaand")
                                ])
                              ])
                            : _c("div", [
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v(_vm._s(call.telephoneNumber))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col col-100" }, [
                                  _vm._v("Inkomend")
                                ])
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col col-50" }, [
                          _c("div", { staticClass: "col col-90" }, [
                            _vm._v(
                              _vm._s(_vm.convertToDayMonth(call.date)) +
                                " " +
                                _vm._s(_vm.convertToClock(call.time))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col col-90" }, [
                            _vm._v(_vm._s(_vm.convertToDuration(call.duration)))
                          ]),
                          _vm._v(" "),
                          call.type == "O"
                            ? _c("div", { staticClass: "call-type-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/outboundcall.svg")
                                  }
                                })
                              ])
                            : _c("div", { staticClass: "call-type-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/inboundcall.svg")
                                  }
                                })
                              ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Specificaties")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Verbruik")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row explanation" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v(
          "\n                Nog geen gegevens beschikbaar. Probeer het later nog een keer.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ceab121", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ceab121","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usage.vue
// module id = null
// module chunks = 